/**
 * Network Status Component
 * Shows online/offline status only (online-only mode)
 */

import React, { useEffect, useState } from 'react';
import { Wifi, WifiOff } from 'lucide-react';

interface NetworkStatusProps {
  className?: string;
}

export const NetworkStatus: React.FC<NetworkStatusProps> = ({ className = '' }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    // Only use browser's online/offline status - no API calls
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Set initial state based on browser
    setIsOnline(navigator.onLine);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <div className={`flex items-center gap-2 text-sm ${className}`}>
      {isOnline ? (
        <Wifi className="h-4 w-4 text-green-500" title="Online" />
      ) : (
        <WifiOff className="h-4 w-4 text-red-500" title="Offline - Server connection required" />
      )}
      <span className="text-gray-500 text-xs">
        {isOnline ? 'Online' : 'Offline'}
      </span>
    </div>
  );
};
